import { Directive, ElementRef, Input } from '@angular/core';
import { CdkDropList } from '@angular/cdk/drag-drop';

@Directive({
  selector: '[cdkDropList][actualContainer]',
})
export class CdkDropListDirective {
  @Input() actualContainer: string;
  originalElement: ElementRef<HTMLElement>;

  constructor(cdkDropList: CdkDropList) {
    cdkDropList._dropListRef.beforeStarted.subscribe(() => {
      if (!this.originalElement) {
        this.originalElement = cdkDropList.element;
      }

      if (this.actualContainer) {
        const element = this.originalElement.nativeElement.closest(
          this.actualContainer
        ) as HTMLElement;
        cdkDropList.element = new ElementRef<HTMLElement>(element);
        cdkDropList._dropListRef.element = element;
      } else {
        cdkDropList.element = this.originalElement;
        cdkDropList._dropListRef.element = cdkDropList.element.nativeElement;
      }
    });
  }
}
